import { getUserId } from "../utils/storage";

/** Cart APIs expect userId (staff _id) in the body. */
export const userBody = (extra = {}) => ({
  userId: getUserId(),
  ...extra,
});
